// CadastreInfoComponent.js
import { useEffect, useState } from "react";
import { Appliances, Document, Eye, Plus } from "assets/icons"; // Replace with appropriate icons
import { BuildingDTO } from "shared/types/building";
import { UnitDTO } from "shared/types/unit";
import ButtonNew from "components/buttonNew/buttonNew";
import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@heroui/react";
import DeviceDetailModal from "./devicesDetailModal";
import { Device } from "shared/types/device";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { API_URL } from "constants/index";
import { useSession } from "@clerk/clerk-react";

interface DevicesInfoComponentProps {
  handleUnitConformityInfoChangeInParent?: (value: any) => any;
  handleSaveInParent?: () => any;
  handleCloseParent?: () => any;
  building: BuildingDTO;
  unit: UnitDTO;
  parentEditMode?: boolean;
}

const DevicesInfoComponent = ({ unit }: DevicesInfoComponentProps) => {
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [isDeviceDetailModalOpen, setIsDeviceDetailModalOpen] = useState(false);
  const [isAddDeviceModalOpen, setIsAddDeviceModalOpen] = useState(false);
  const [devices, setDevices] = useState([]);
  const { session } = useSession();

  const fetchDevices = async () => {
    let res = await fetchWithAuth(
      `${API_URL}/devices/${unit.id}`,
      {
        method: "GET",
      },
      session,
    );

    const unitDevices = await res.json();

    console.log(unitDevices);
    setDevices(unitDevices);
  };

  useEffect(() => {
    console.log("Fetching devices for unit");
    console.log(unit);
    if (unit && unit.id) {
      fetchDevices();
    }
  }, [unit.id, unit.devices?.length]);

  const handleOpenViewDeviceModal = (device: any) => {
    setSelectedDevice(device);
    setIsDeviceDetailModalOpen(true);
  };
  const handleOpenAddDeviceModal = () => {
    setIsAddDeviceModalOpen(true);
  };
  const handleCloseAddDeviceModal = () => {
    setIsAddDeviceModalOpen(false);
  };
  const handleCloseDeviceDetailModal = () => {
    setSelectedDevice(null);
    setIsDeviceDetailModalOpen(false);
  };

  return (
    <section className="col-span-full flex flex-col gap-0 rounded-md bg-white">
      <div key="devices" className="col-span-full flex flex-col gap-3">
        <header className="flex justify-between">
          <div className="flex items-center gap-2">
            <Appliances className="h-[18px] w-[18px]" />{" "}
            {/* Ensure you have an appropriate icon */}
            <p className="text-lg">Toestellen</p>
          </div>
          <ButtonNew
            onClick={() => handleOpenAddDeviceModal()}
            icon={<Plus />}
            label="Toestel toevoegen"
            variant="primaryMoss"
          />
        </header>
        <Table
          classNames={{
            wrapper: "shadow-none rounded-none p-0",
            thead: "h-fit border-b-2 border-neutral-primary/40",
            th: "rounded-none! bg-white py-2 h-fit text-sm text-neutral-primary font-medium",
            tbody: "border-b divide-y divide-neutral-primary/15",
            tr: "divide-x divide-neutral-primary/15",
            td: "py-2.5",
          }}
        >
          <TableHeader>
            {/* <TableColumn>Foto's</TableColumn> */}
            <TableColumn>Type</TableColumn>
            <TableColumn>Merk</TableColumn>
            <TableColumn>Model</TableColumn>
            <TableColumn>Energielabel</TableColumn>
            <TableColumn>Locatie</TableColumn>
            <TableColumn>Technische Fiche</TableColumn>
            <TableColumn>Detail</TableColumn>
          </TableHeader>
          <TableBody>
            {devices &&
              (devices as any).map((device: Device, index: any) => (
                <TableRow key={index}>
                  {/* <TableCell>
                    <ImagesContainer
                      pageSize={1}
                      fileLabel={PictureLabel.DevicePictureUnit as any}
                      canUpload={false}
                      fetchOnlyPredefinedFileLogIds={true}
                      fileLogIds={device?.devicePicturesFileLogIds}
                    />
                  </TableCell> */}
                  <TableCell>{device.deviceType}</TableCell>
                  <TableCell>{device.brand}</TableCell>
                  <TableCell>{device.model}</TableCell>
                  <TableCell>{device.energyLabel}</TableCell>
                  <TableCell>{device.location || "N/A"}</TableCell>
                  <TableCell>
                    {device.invoiceFileLog ? (
                      <a
                        href={device.invoiceFileLog.sharePointFileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="flex gap-2">
                          Bekijk document{" "}
                          <Document className="cursor-pointer" />
                        </span>
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                  <TableCell>
                    <span
                      onClick={() => handleOpenViewDeviceModal(device)}
                      className="cursor-pointer bg-transparent text-moss-primary"
                    >
                      <Eye />
                    </span>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      {selectedDevice && (
        <DeviceDetailModal
          isOpen={isDeviceDetailModalOpen}
          onClose={handleCloseDeviceDetailModal}
          unit={unit ? unit : null}
          device={selectedDevice ? selectedDevice : null}
          fetchDevices={fetchDevices}
        />
      )}
      {
        <DeviceDetailModal
          isOpen={isAddDeviceModalOpen}
          onClose={handleCloseAddDeviceModal}
          unit={unit ? unit : null}
          device={selectedDevice ? selectedDevice : null}
          fetchDevices={fetchDevices}
        />
      }
    </section>
  );
};

export default DevicesInfoComponent;
